import { render, staticRenderFns } from "./PageFooter.vue?vue&type=template&id=4d415a45&scoped=true"
import script from "./PageFooter.vue?vue&type=script&lang=ts&setup=true"
export * from "./PageFooter.vue?vue&type=script&lang=ts&setup=true"
import style0 from "./PageFooter.vue?vue&type=style&index=0&id=4d415a45&prod&lang=sass&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4d415a45",
  null
  
)

export default component.exports